import { httpClient } from "../../httpClient";
import { VIP } from "../../../store";

type Payload = {
    id: number;
    vipEmail: string;
    void: boolean;
    active: boolean;
    approverEmail: string;
};

type Data = any;

export async function postVIP(payload: Payload): Promise<any> {
  try {
      const { data } = await httpClient.post<Data>(`/api/v1/vips`, payload);

    return data;
  } catch (error) {
      console.log(error);
    throw error;
  }
}

export async function editVIP(id: VIP["id"], payload: Payload): Promise<boolean> {
    try {
        const response = await httpClient.put(`/api/v1/vips/${id}`, payload);

        return response.status === 200;
    } catch (error) {
        throw error;
    }
}

export const vip = {
    postVIP,
    editVIP,
};